import { createSlice } from '@reduxjs/toolkit';

export const tipoCotizacionSlice = createSlice({
  name: 'tipoCotizacion',
  initialState: {
    tipoCotizacionesList: [],
    tipoCotizacionCamposList: [],
    tipoCotizacion: {},
  },
  reducers: {
    setTipoCotizacionesListRedux: (state, { payload }) => {
      state.tipoCotizacionesList = payload;
    },
    setTipoCotizacionRedux: (state, { payload }) => {
      state.tipoCotizacion = payload;
    },
    setTipoCotizacionCamposRedux: (state, { payload }) => {
      state.tipoCotizacionCamposList = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setTipoCotizacionesListRedux,
  setTipoCotizacionRedux,
  setTipoCotizacionCamposRedux,
} = tipoCotizacionSlice.actions;
